import { render, staticRenderFns } from "./SeccionPlanes.vue?vue&type=template&id=62cb0542&scoped=true"
import script from "./SeccionPlanes.vue?vue&type=script&lang=js"
export * from "./SeccionPlanes.vue?vue&type=script&lang=js"
import style0 from "./SeccionPlanes.vue?vue&type=style&index=0&id=62cb0542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cb0542",
  null
  
)

export default component.exports